import { type Model, modelListSchema } from '@ytclip/shared'
import { apiRequest } from '@/lib/api-client.ts'

export async function fetchModels(): Promise<Model[]> {
  const response = await apiRequest('/models', modelListSchema)
  return response.data
}
